import { getQueryParam } from './get-query-param';

export function getIsSupercellTemplate() {
  const template = getQueryParam('template').toLowerCase();
  return template === 'supercell';
}

export function initSupercellFonts() {
  if (getIsSupercellTemplate()) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.supercell.com/fonts/supercell/fonts_supercelltext_full.css';
    document.head.appendChild(link);
  }
}
